// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSWarning from "../Fusion.Data.FSWarning/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var bytesIsSymbol = {
    reflectSymbol: function () {
        return "bytes";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(bytesIsSymbol);
var streamSpeedsIsSymbol = {
    reflectSymbol: function () {
        return "streamSpeeds";
    }
};
var totalSpeedIsSymbol = {
    reflectSymbol: function () {
        return "totalSpeed";
    }
};
var speedIsSymbol = {
    reflectSymbol: function () {
        return "speed";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(speedIsSymbol);
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(timestampIsSymbol)(Fusion_Data_Timestamp.showTimestamp);
var showRecord1 = /* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsConsNil)(Fusion_Data_Speed.showSpeed));
var CurrentIsSymbol = {
    reflectSymbol: function () {
        return "Current";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRecord1));
var TotalIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "TotalIntermediate";
    }
};
var streamIndexIsSymbol = {
    reflectSymbol: function () {
        return "streamIndex";
    }
};
var showRecordFieldsCons2 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(streamIndexIsSymbol);
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ showRecordFieldsCons2(showRecordFieldsConsNil)(Data_Show.showInt))(Fusion_Data_Speed.showSpeed))));
var StreamIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "StreamIntermediate";
    }
};
var kernelNameIsSymbol = {
    reflectSymbol: function () {
        return "kernelName";
    }
};
var kernelVersionIsSymbol = {
    reflectSymbol: function () {
        return "kernelVersion";
    }
};
var statsIsSymbol = {
    reflectSymbol: function () {
        return "stats";
    }
};
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(urlIsSymbol)(MST_Data_BasicURL.showBasicURL);
var genericShowConstructor2 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(kernelNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(kernelVersionIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(statsIsSymbol)(showRecordFieldsConsNil1)(Data_TransmissionStats.showTransmissionStats))(Data_Show.showString))(Data_Show.showString))));
var IntermediateStatsPassiveIsSymbol = {
    reflectSymbol: function () {
        return "IntermediateStatsPassive";
    }
};
var IntermediateStatsActiveIsSymbol = {
    reflectSymbol: function () {
        return "IntermediateStatsActive";
    }
};
var loadedBytesIsSymbol = {
    reflectSymbol: function () {
        return "loadedBytes";
    }
};
var startTimeIsSymbol = {
    reflectSymbol: function () {
        return "startTime";
    }
};
var durationSinceStartIsSymbol = {
    reflectSymbol: function () {
        return "durationSinceStart";
    }
};
var ServerSideLoadedBytesIsSymbol = {
    reflectSymbol: function () {
        return "ServerSideLoadedBytes";
    }
};
var ServerSideStreamIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "ServerSideStreamIntermediate";
    }
};
var ServerSideTotalIntermediateIsSymbol = {
    reflectSymbol: function () {
        return "ServerSideTotalIntermediate";
    }
};
var warningIsSymbol = {
    reflectSymbol: function () {
        return "warning";
    }
};
var WarningIsSymbol = {
    reflectSymbol: function () {
        return "Warning";
    }
};
var jitterIsSymbol = {
    reflectSymbol: function () {
        return "jitter";
    }
};
var statsActiveIsSymbol = {
    reflectSymbol: function () {
        return "statsActive";
    }
};
var statsPassiveIsSymbol = {
    reflectSymbol: function () {
        return "statsPassive";
    }
};
var FinalIsSymbol = {
    reflectSymbol: function () {
        return "Final";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Bytes.eqBytes);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(timestampIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))()(speedIsSymbol)(Fusion_Data_Speed.eqSpeed))));
var eq2 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Speed.eqSpeed);
var eq3 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Timestamp.eqTimestamp);
var eq6 = /* #__PURE__ */ Data_Eq.eq(Data_TransmissionStats.eqTransmissionStats);
var eq7 = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var eq8 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Array_NonEmpty_Internal.eqNonEmptyArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(durationSinceStartIsSymbol)(Fusion_Data_Duration.eqDuration))()(bytesIsSymbol)(Fusion_Data_Bytes.eqBytes))));
var eq9 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_FSWarning.eqFSWarning);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Speed.encodeJsonSpeed);
var gEncodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Timestamp.encodeJsonTimestamp);
var gEncodeJsonCons3 = /* #__PURE__ */ gEncodeJsonCons2(Data_Argonaut_Encode_Class.gEncodeJsonNil)(timestampIsSymbol)();
var encodeRecord = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(gEncodeJsonCons3)(speedIsSymbol)())();
var encodeRepArgsArgument = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(encodeRecord);
var gEncodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var encodeRepArgsArgument1 = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons4(gEncodeJsonCons3)(streamIndexIsSymbol)())(speedIsSymbol)())());
var gEncodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons6 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_TransmissionStats.encodeJsonTransmissionSta);
var gEncodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_BasicURL.encodeJsonBasicURL)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(urlIsSymbol)();
var encodeRepArgsArgument2 = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons6(gEncodeJsonCons7)(statsIsSymbol)())(kernelVersionIsSymbol)())(kernelNameIsSymbol)())());
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Bytes.decodeJsonBytes));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Speed.decodeJsonSpeed));
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Timestamp.decodeJsonTimestamp));
var gDecodeJsonCons3 = /* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil)(timestampIsSymbol)()();
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(gDecodeJsonCons3)(speedIsSymbol)()())();
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var decodeRecord1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons4(gDecodeJsonCons3)(streamIndexIsSymbol)()())(speedIsSymbol)()())();
var gDecodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons6 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_TransmissionStats.decodeJsonTransmissionSta));
var gDecodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_BasicURL.decodeJsonBasicURL))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(urlIsSymbol)()();
var decodeRecord2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons6(gDecodeJsonCons7)(statsIsSymbol)()())(kernelVersionIsSymbol)()())(kernelNameIsSymbol)()())();
var Current = /* #__PURE__ */ (function () {
    function Current(value0) {
        this.value0 = value0;
    };
    Current.create = function (value0) {
        return new Current(value0);
    };
    return Current;
})();
var TotalIntermediate = /* #__PURE__ */ (function () {
    function TotalIntermediate(value0) {
        this.value0 = value0;
    };
    TotalIntermediate.create = function (value0) {
        return new TotalIntermediate(value0);
    };
    return TotalIntermediate;
})();
var StreamIntermediate = /* #__PURE__ */ (function () {
    function StreamIntermediate(value0) {
        this.value0 = value0;
    };
    StreamIntermediate.create = function (value0) {
        return new StreamIntermediate(value0);
    };
    return StreamIntermediate;
})();
var IntermediateStatsPassive = /* #__PURE__ */ (function () {
    function IntermediateStatsPassive(value0) {
        this.value0 = value0;
    };
    IntermediateStatsPassive.create = function (value0) {
        return new IntermediateStatsPassive(value0);
    };
    return IntermediateStatsPassive;
})();
var IntermediateStatsActive = /* #__PURE__ */ (function () {
    function IntermediateStatsActive(value0) {
        this.value0 = value0;
    };
    IntermediateStatsActive.create = function (value0) {
        return new IntermediateStatsActive(value0);
    };
    return IntermediateStatsActive;
})();
var ServerSideLoadedBytes = /* #__PURE__ */ (function () {
    function ServerSideLoadedBytes(value0) {
        this.value0 = value0;
    };
    ServerSideLoadedBytes.create = function (value0) {
        return new ServerSideLoadedBytes(value0);
    };
    return ServerSideLoadedBytes;
})();
var ServerSideStreamIntermediate = /* #__PURE__ */ (function () {
    function ServerSideStreamIntermediate(value0) {
        this.value0 = value0;
    };
    ServerSideStreamIntermediate.create = function (value0) {
        return new ServerSideStreamIntermediate(value0);
    };
    return ServerSideStreamIntermediate;
})();
var ServerSideTotalIntermediate = /* #__PURE__ */ (function () {
    function ServerSideTotalIntermediate(value0) {
        this.value0 = value0;
    };
    ServerSideTotalIntermediate.create = function (value0) {
        return new ServerSideTotalIntermediate(value0);
    };
    return ServerSideTotalIntermediate;
})();
var Warning = /* #__PURE__ */ (function () {
    function Warning(value0) {
        this.value0 = value0;
    };
    Warning.create = function (value0) {
        return new Warning(value0);
    };
    return Warning;
})();
var Final = /* #__PURE__ */ (function () {
    function Final(value0) {
        this.value0 = value0;
    };
    Final.create = function (value0) {
        return new Final(value0);
    };
    return Final;
})();
var isFinalLoadOutput = {
    isFinal: function (v) {
        if (v instanceof Current) {
            return false;
        };
        if (v instanceof TotalIntermediate) {
            return false;
        };
        if (v instanceof StreamIntermediate) {
            return false;
        };
        if (v instanceof IntermediateStatsPassive) {
            return false;
        };
        if (v instanceof IntermediateStatsActive) {
            return false;
        };
        if (v instanceof ServerSideLoadedBytes) {
            return false;
        };
        if (v instanceof ServerSideStreamIntermediate) {
            return false;
        };
        if (v instanceof ServerSideTotalIntermediate) {
            return false;
        };
        if (v instanceof Warning) {
            return false;
        };
        if (v instanceof Final) {
            return true;
        };
        throw new Error("Failed pattern match at Fusion.LoadOutput (line 77, column 13 - line 87, column 20): " + [ v.constructor.name ]);
    }
};
var genericLoadOutput_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Current(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new TotalIntermediate(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new StreamIntermediate(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new IntermediateStatsPassive(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new IntermediateStatsActive(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new ServerSideLoadedBytes(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new ServerSideStreamIntermediate(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new ServerSideTotalIntermediate(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new Warning(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))) {
            return new Final(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Fusion.LoadOutput (line 63, column 1 - line 63, column 37): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Current) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof TotalIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof StreamIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof IntermediateStatsPassive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof IntermediateStatsActive) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof ServerSideLoadedBytes) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof ServerSideStreamIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof ServerSideTotalIntermediate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof Warning) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof Final) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))))));
        };
        throw new Error("Failed pattern match at Fusion.LoadOutput (line 63, column 1 - line 63, column 37): " + [ x.constructor.name ]);
    }
};
var showLoadOutput = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericLoadOutput_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons(streamSpeedsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(totalSpeedIsSymbol)(showRecord1))(/* #__PURE__ */ Data_Show.showArray(showRecord1)))(Fusion_Data_Bytes.showBytes))))(CurrentIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(TotalIntermediateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(StreamIntermediateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(IntermediateStatsPassiveIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(IntermediateStatsActiveIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(loadedBytesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(startTimeIsSymbol)(/* #__PURE__ */ showRecordFieldsCons2(showRecordFieldsConsNil1)(Data_Show.showInt))(Fusion_Data_Timestamp.showTimestamp))(/* #__PURE__ */ Data_Array_NonEmpty_Internal.showNonEmptyArray(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(durationSinceStartIsSymbol)(Fusion_Data_Duration.showDuration))(Fusion_Data_Bytes.showBytes)))))))(ServerSideLoadedBytesIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(ServerSideStreamIntermediateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ServerSideTotalIntermediateIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ Data_Show.showRecordFieldsCons(timestampIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(warningIsSymbol)(Fusion_Data_FSWarning.showFSWarning))(Fusion_Data_Timestamp.showTimestamp))(Data_Show.showInt))))(WarningIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(jitterIsSymbol)(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsCons(statsActiveIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(statsPassiveIsSymbol)(Data_TransmissionStats.showTransmissionStats))(Data_TransmissionStats.showTransmissionStats))(Fusion_Data_Speed.showSpeed))(Fusion_Data_Speed.showSpeed))))(FinalIsSymbol)))))))))))
};
var eqLoadOutput = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Current && y instanceof Current) {
                return eq(x.value0.bytes)(y.value0.bytes) && eq1(x.value0.streamSpeeds)(y.value0.streamSpeeds) && (eq2(x.value0.totalSpeed.speed)(y.value0.totalSpeed.speed) && eq3(x.value0.totalSpeed.timestamp)(y.value0.totalSpeed.timestamp));
            };
            if (x instanceof TotalIntermediate && y instanceof TotalIntermediate) {
                return eq2(x.value0.speed)(y.value0.speed) && eq3(x.value0.timestamp)(y.value0.timestamp);
            };
            if (x instanceof StreamIntermediate && y instanceof StreamIntermediate) {
                return eq2(x.value0.speed)(y.value0.speed) && x.value0.streamIndex === y.value0.streamIndex && eq3(x.value0.timestamp)(y.value0.timestamp);
            };
            if (x instanceof IntermediateStatsPassive && y instanceof IntermediateStatsPassive) {
                return x.value0.kernelName === y.value0.kernelName && x.value0.kernelVersion === y.value0.kernelVersion && eq6(x.value0.stats)(y.value0.stats) && eq7(x.value0.url)(y.value0.url);
            };
            if (x instanceof IntermediateStatsActive && y instanceof IntermediateStatsActive) {
                return x.value0.kernelName === y.value0.kernelName && x.value0.kernelVersion === y.value0.kernelVersion && eq6(x.value0.stats)(y.value0.stats) && eq7(x.value0.url)(y.value0.url);
            };
            if (x instanceof ServerSideLoadedBytes && y instanceof ServerSideLoadedBytes) {
                return eq8(x.value0.loadedBytes)(y.value0.loadedBytes) && eq3(x.value0.startTime)(y.value0.startTime) && x.value0.streamIndex === y.value0.streamIndex && eq7(x.value0.url)(y.value0.url);
            };
            if (x instanceof ServerSideStreamIntermediate && y instanceof ServerSideStreamIntermediate) {
                return eq2(x.value0.speed)(y.value0.speed) && x.value0.streamIndex === y.value0.streamIndex && eq3(x.value0.timestamp)(y.value0.timestamp);
            };
            if (x instanceof ServerSideTotalIntermediate && y instanceof ServerSideTotalIntermediate) {
                return eq2(x.value0.speed)(y.value0.speed) && eq3(x.value0.timestamp)(y.value0.timestamp);
            };
            if (x instanceof Warning && y instanceof Warning) {
                return x.value0.streamIndex === y.value0.streamIndex && eq3(x.value0.timestamp)(y.value0.timestamp) && eq9(x.value0.warning)(y.value0.warning);
            };
            if (x instanceof Final && y instanceof Final) {
                return eq2(x.value0.jitter)(y.value0.jitter) && eq2(x.value0.speed)(y.value0.speed) && eq6(x.value0.statsActive)(y.value0.statsActive) && eq6(x.value0.statsPassive)(y.value0.statsPassive);
            };
            return false;
        };
    }
};
var encodeJsonLoadOutput = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericLoadOutput_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(CurrentIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encodeRecord))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeRecord)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(totalSpeedIsSymbol)())(streamSpeedsIsSymbol)())(bytesIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(TotalIntermediateIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StreamIntermediateIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(IntermediateStatsPassiveIsSymbol)(encodeRepArgsArgument2))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(IntermediateStatsActiveIsSymbol)(encodeRepArgsArgument2))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ServerSideLoadedBytesIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Duration.encodeJsonDuration)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(durationSinceStartIsSymbol)())(bytesIsSymbol)())()))(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons4(gEncodeJsonCons7)(streamIndexIsSymbol)())(startTimeIsSymbol)())(loadedBytesIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ServerSideStreamIntermediateIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ServerSideTotalIntermediateIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(WarningIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons4(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_FSWarning.encodeJsonFSWarning)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(warningIsSymbol)())(timestampIsSymbol)())(streamIndexIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons6(/* #__PURE__ */ gEncodeJsonCons6(Data_Argonaut_Encode_Class.gEncodeJsonNil)(statsPassiveIsSymbol)())(statsActiveIsSymbol)())(speedIsSymbol)())(jitterIsSymbol)())()))))))))))))
};
var decodeJsonLoadOutput = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericLoadOutput_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(CurrentIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(decodeRecord)))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(totalSpeedIsSymbol)()())(streamSpeedsIsSymbol)()())(bytesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(TotalIntermediateIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StreamIntermediateIsSymbol)(decodeRecord1))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(IntermediateStatsPassiveIsSymbol)(decodeRecord2))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(IntermediateStatsActiveIsSymbol)(decodeRecord2))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ServerSideLoadedBytesIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Duration.decodeJsonDuration))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(durationSinceStartIsSymbol)()())(bytesIsSymbol)()())())))(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons4(gDecodeJsonCons7)(streamIndexIsSymbol)()())(startTimeIsSymbol)()())(loadedBytesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ServerSideStreamIntermediateIsSymbol)(decodeRecord1))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ServerSideTotalIntermediateIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(WarningIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_FSWarning.decodeJsonFSWarning))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(warningIsSymbol)()())(timestampIsSymbol)()())(streamIndexIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(FinalIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons6(/* #__PURE__ */ gDecodeJsonCons6(Data_Argonaut_Decode_Class.gDecodeJsonNil)(statsPassiveIsSymbol)()())(statsActiveIsSymbol)()())(speedIsSymbol)()())(jitterIsSymbol)()())())))))))))))
};
export {
    Current,
    TotalIntermediate,
    StreamIntermediate,
    IntermediateStatsPassive,
    IntermediateStatsActive,
    ServerSideLoadedBytes,
    ServerSideStreamIntermediate,
    ServerSideTotalIntermediate,
    Warning,
    Final,
    genericLoadOutput_,
    encodeJsonLoadOutput,
    decodeJsonLoadOutput,
    showLoadOutput,
    eqLoadOutput,
    isFinalLoadOutput
};
//# sourceMappingURL=index.js.map
